module.exports = new __parcel__URL__("raijus_grave_level_1.197d3e44.png").toString();